import { List, Create, Edit, CreateOfficer, LedgerBarcode, GuestBarcode } from "../Components/index.js";

export default [
    {
        path: "/fd/ledger/list",
        component: List,
        name: "fd.account.ledger.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/ledger/create",
        component: Create,
        name: "fd.account.ledger.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/ledger/create-officer",
        component: CreateOfficer,
        name: "fd.account.ledger.create.officer",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/ledger/:id/edit",
        component: Edit,
        name: "fd.account.ledger.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/ledger-barcode",
        component: LedgerBarcode,
        name: "fd.account.ledger.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/ledger-guest-barcode",
        component: GuestBarcode,
        name: "fd.account.ledger.guest.barcode",
        meta: {
            requiresAuth: true,
        },
    },
];
